import React from 'react';

import { useNewRoleContext } from 'lib/context/Role/NewRoleContext/NewRoleContext';

import Button from 'components/shared/Button/Button';
import ErrorBoundary from 'components/shared/Error/Boundary';
import ErrorMessage from 'components/shared/ErrorMessage/ErrorMessage';

const FooterButtons = ({
  buttonText,
  nextTo,
  backTo,
  isLastStep,
  setBreadCrumbs,
  firstStep,
  ableToSave
}) => {
  const {
    enableNextTo,
    formik,
    showNavigationButtons,
    handleClose,
    isEdit,
    enableSubmit,
    setIsSaveAndExit
  } = useNewRoleContext();

  const navigateViews = ({ componentToView = '', isNext = false }) => {
    setBreadCrumbs((prevCrumbs) =>
      prevCrumbs.map((crumb) => {
        if (crumb.view === componentToView) {
          return { ...crumb, active: true };
        } else if (isNext && crumb.active && !crumb.isFinished) {
          return { ...crumb, isFinished: true, active: false };
        } else {
          return { ...crumb, active: false };
        }
      })
    );
  };

  const handleSubmit = (hasSaveAndExit) => {
    if (hasSaveAndExit) {
      setIsSaveAndExit(true);
    }
    formik.handleSubmit();
  };

  const handleOnClick = () => {
    if (!firstStep) {
      navigateViews({ componentToView: backTo });
    } else {
      handleClose();
    }
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div className="flex w-full items-center justify-end">
        {showNavigationButtons ? (
          <Button
            isDisabled={firstStep ? false : !backTo}
            style="outlined"
            color="neutral"
            text={firstStep ? 'Close' : 'Back'}
            data-qa="back-btn"
            onClick={() => handleOnClick()}
          />
        ) : (
          <Button
            color="neutral"
            text="Close"
            style="outlined"
            onClick={handleClose}
            data-qa="close-btn"
          />
        )}
        <div className="flex-end flex gap-4">
          {showNavigationButtons && nextTo && (
            <>
              {ableToSave && (
                <Button
                  isDisabled={!enableNextTo}
                  text="Save Without Assigning"
                  onClick={() => handleSubmit()}
                  data-qa="save-without-assigning-btn"
                />
              )}
              <Button
                isDisabled={!enableNextTo}
                text={buttonText}
                onClick={() => navigateViews({ componentToView: nextTo, isNext: true })}
                data-qa={`${buttonText}-btn`}
              />
            </>
          )}
          {isLastStep && (
            <Button
              text={buttonText ? buttonText : isEdit ? 'Update' : 'Add'}
              onClick={() => handleSubmit()}
              isDisabled={!enableSubmit}
              data-qa="submit-btn"
            />
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default FooterButtons;
